var he_IL = require("./he_IL");
var ru_RU = require("./ru_RU");

exports.InitSource = (language, store, cb) => {
    let source = '';    
    switch(language){
        case "he_IL":
            source = he_IL
        break;
        case "ru_RU":
            source = ru_RU
        break;
    }        
    //INIT LANGUAGE SOURCE
    if(source !==''){        
        store.dispatch('INIT_LANGUAGE_SOURCE', source)
    }   
    
    if(cb !== undefined){
        cb();
    }
    
}

